export function productStageToChart (items = []) {
  const labels = [];
  const datasets = [];

  items.forEach((item, idx) => {
    labels.push(item["Company.companyProductStage"]);

    const data = new Array(items.length);
    data.fill(0, 0, items.length - 1);
    data[idx] = parseInt(item["Company.companiesCount"]);

    datasets.push({
      label: item["Company.companyProductStage"],
      data,
      backgroundColor: "#ea6b8b",
      barThickness: 20
    });
  });

  return {
    labels,
    datasets
  };
}
